import { Grid, Stack } from "@mui/material";
import { m } from "framer-motion";
import Logo from "src/components/Logo";
import useResponsive from "src/hooks/useResponsive";

import InfoHeader from "./components/InfoHeader";
import MobileBtn from "./components/MobileBtn";
import InfoList from "./InfoList";

// ----------------------------------------------------------------------

export const InfoStep = () => {
	const isMobile = useResponsive("down", "sm");

	return (
		<Stack
			component={m.div}
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			transition={{ duration: 0.6 }}
		>
			<Logo sx={{ mb: 4 }} disabledLink />
			<Grid container spacing={4}>
				<Grid item xs={12} sm={6} sx={{ display: "flex", flexDirection: "column" }}>
					<InfoHeader />
				</Grid>
				<Grid item xs={12} sm={6}>
					<InfoList />
				</Grid>
			</Grid>
			{isMobile && <MobileBtn />}
		</Stack>
	);
};

export default InfoStep;
